import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { BaseComponent } from '@app/shared/components/base/base.component';
import { DrLocalStorageService } from '@app/core/services/local-storage/dr-local-storage.service';
import { DrI18nService } from '@app/core/services/i18n/i18n.service';
import { DrFileMeta } from '@app/shared/models/dr-file';
import { EditorApi, PhotoEditorSDKUI, UIEvent } from '@assets/vendor/photoeditorsdk';
import { PhotoEditorConfigService } from '@app/core/services/photo-editor-config.service';


@Component({
    selector: "smp-photo-editor-5",
    templateUrl: "./smp-photo-editor-5.component.html",
    styleUrls: ['./smp-photo-editor-5.component.scss']
})
export class SmpPhotoEditorComponent5 extends BaseComponent implements AfterViewInit {

    @Input()
    public file: DrFileMeta;

    @Input()
    public config?: any;

    @Output()
    public export = new EventEmitter<string>();

    @Output()
    public close = new EventEmitter();

    @ViewChild("psdkContainer")
    private container: ElementRef;

    public editor: EditorApi;

    constructor(protected localStorageService: DrLocalStorageService,
                protected drI18nService: DrI18nService,
                protected photoEditorConfigService: PhotoEditorConfigService) {
        super();
        this._idPrefix = 'smp_photo_editor.';
    }

    private token() {
        const user = this.localStorageService.get(this.localStorageService.STORAGE_KEY_USER);
        return user ? user.accessToken : '';
    }

    public ngAfterViewInit() {
        this.config = this.config || this.photoEditorConfigService.getConfig();

        this.initEditor()
            .then(function() {
            // NO ACTION NEEDED
        });
    }

    protected async initEditor() {
        try {
            if (this.editor) {
                this.editor.dispose();
            }

            const mergedConfig = Object.assign({
                container: this.container.nativeElement,
                image: this.file.link + `?access-token=${this.token()}&version=${this.file.version}`,
            }, this.config);

            this.editor = await PhotoEditorSDKUI.init(mergedConfig);

            this.editor.on(UIEvent.EXPORT, (imgResult) => {
                this.export.emit(imgResult);
            });

            this.editor.on(UIEvent.CLOSE, () => {
                this.close.emit();
            });
        } catch (error) {
            this.handleError(error);
        }
    }
}
